/**
 * Join Thousands / Train With Tymewear: box item active state (delegated click).
 */
(function ($) {
  'use strict';
  $(function () {
    $(document).on('click', '.JTH_TWT .TWT_B_BI_Inner', function () {
      var getNthPos = parseInt($(this).parent().data('childno'), 10);
      var boxItems = $(this).closest('.TWT_B_BoxItems');
      if (getNthPos > 0 && getNthPos <= 3) {
        boxItems.find('.TWT_B_BI_Inner').removeClass('TWT_BBI_Active');
        $(this).addClass('TWT_BBI_Active');
        boxItems.attr('data-active', getNthPos);
      }
    });
  });
})(jQuery);
